import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from 'src/services/auth.service';

// Route guard for /report.
//
// DESIGN DECISION (intentional tradeoff):
// The login FORM lives INSIDE ReportComponent and the component already toggles
// between the login form and the report via `isLogin` (driven by
// AuthService.isAuthenticated()). A guard that blocks /report when the user is
// not authenticated would also block the login screen and lock the user out.
//
// Therefore this guard ALWAYS allows /report to activate and lets the component
// render the login form for unauthenticated users. The real protection comes
// from:
//   1) AuthService.isAuthenticated() gating the report UI inside the component,
//   2) the AuthInterceptor attaching the bearer token and clearing state on
//      401/403, and
//   3) the BE validating the token on every data API (the authoritative check).
//
// The guard is kept as an explicit, documented extension point. If a future
// dedicated /login route is added, switch this to deny when not authenticated
// and redirect there.
export const authGuard: CanActivateFn = () => {
  // Touch the service so the auth state is initialised; access is intentionally
  // allowed regardless (see note above). This is a UX gate, not the security
  // boundary — BE is the source of truth.
  inject(AuthService).isAuthenticated();
  return true;
};
